import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useUpdateEffect } from 'react-use';

import UILoadmore from '@src/components/UILoadmore';
import { IconArrBottom } from '@src/components/Icon';

import useStyles from 'isomorphic-style-loader/useStyles';
import css from './style.module.sass';

const ProfilePack = (props) => {
	useStyles(css);
	const {
		labels = [
			{ label: t('Название') },
			{ label: t('Вместимость') },
			{ label: t('Пространства') },
			{ label: t('Схема оплаты') },
		],
		items,
		onClick,
		isOpen,
	} = props;

	const [isOpenState, setIsOpen] = React.useState(isOpen);

	useUpdateEffect(() => {
		setIsOpen(isOpen);
	}, [isOpen]);

	const handleClickItem = React.useCallback(
		(e, item) => {
			if (onClick) {
				onClick(e, item);
			}
		},
		[onClick],
	);

	const handleClickLoadmore = React.useCallback(() => {
		setIsOpen(true);
	}, []);

	return (
		<div className={css.group}>
			{Boolean(labels) && (
				<div className={css.item}>
					{labels.map(({ label }) => (
						<div className={css.label} key={label}>
							{label}
						</div>
					))}
				</div>
			)}

			<div
				className={cn(css.wrap, {
					[css['wrap--status--nonactive']]: !isOpenState,
				})}
			>
				{items.map((item) => {
					const { name, capacity, desc, plans } = item;

					return (
						<div
							className={css.item}
							role="button"
							tabIndex={0}
							onClick={(e) => handleClickItem(e, item)}
							key={`${name}-${desc}`}
						>
							{name && (
								<div className={css.name}>
									<div className={css.nameItem}>{name}</div>
									<div
										className={cn(
											css.nameItem,
											css.nameLink,
										)}
									>
										{t('Подробнее')}
									</div>
								</div>
							)}

							{capacity && (
								<div className={css.capacity}>
									{capacity}
									<div className={css.capacityItem}>
										{typeof capacity === 'number'
											? t(
													'человек|человека|человек',
													capacity,
											  )
											: t('человек')}
									</div>
								</div>
							)}

							{desc && <div className={css.desc}>{desc}</div>}

							{Boolean(plans) && (
								<div className={css.plans}>
									{plans.map(({ label, prices }) => (
										<div className={css.plan} key={label}>
											{label}
											<div className={css.prices}>
												{prices.map((price) => (
													<div
														className={css.price}
														key={`${price.value}-${price.label}`}
													>
														{price.value}
														{price.label && (
															<div
																className={
																	css.priceItem
																}
															>
																{`/ ${price.label}`}
															</div>
														)}
													</div>
												))}
											</div>
										</div>
									))}
								</div>
							)}
						</div>
					);
				})}

				{!isOpenState && (
					<div className={css.loadmore}>
						<UILoadmore
							label={t('Показать ещё')}
							Icon={IconArrBottom}
							onClick={handleClickLoadmore}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

ProfilePack.propTypes = {
	labels: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string })),
	items: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			capacity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			desc: PropTypes.string,
			plans: PropTypes.arrayOf(
				PropTypes.shape({
					label: PropTypes.string,
					prices: PropTypes.arrayOf(
						PropTypes.shape({
							value: PropTypes.string,
							label: PropTypes.string,
						}),
					),
				}),
			),
		}),
	),
	onClick: PropTypes.func,
	isOpen: PropTypes.bool,
};

ProfilePack.defaultProps = {
	labels: undefined,
	items: [],
	onClick: undefined,
	isOpen: undefined,
};

export default ProfilePack;
